import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { auth } from "@/components/firebaseInit"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import '@/sass/main.scss'

let app;
auth.onAuthStateChanged(() => {
  if(!app) {
    app = createApp(App).use(i18n).use(router).mount('#app')
  }
})

